import { z } from 'zod';
import { useMemo } from 'react';
import { TMDXFile } from '@/api/apis/files';
import { STATE_SCHEMA } from '@/utils/helpers';
import { useCountriesData } from '@/contexts/CountriesDataProvider';
import { NameByValue } from '@/types';
import { NewHubForm } from './types';
import { createHubFormValidation } from './utils';

export const DEFAULT_HUB_VALUES: NewHubForm = {
  name: '',
  code: '',
  timezone: '',
  timezoneIANA: '',
  regionId: '',
  region: '',
  addressId: '',
  addressLine: '',
  city: '',
  state: null,
  postalCode: '',
  country: '',
  nationalManagerId: '',
  nationalManagerName: '',
  regionalManagerId: '',
  regionalManagerName: '',
  longitude: 0,
  latitude: 0,
  isSuperHub: false,
};

export const hubFormSchema = (composedSubdivisionsList: Record<string, NameByValue[]>) =>
  z
    .object({
      name: z.string().min(1, 'Provide hub name'),
      code: z.string().min(1, 'Provide hub code'),
      image: z.custom<TMDXFile>().optional(),
      logoPath: z.string().optional(),
      timezone: z.string(),
      timezoneIANA: z.string(),
      regionId: z.string().min(1, 'Provide region'),
      region: z.string().min(1, 'Provide region'),
      addressId: z.string().optional(),
      addressLine: z.string().min(1, 'Provide hub address'),
      city: z.string().min(1, 'Provide hub city'),
      state: STATE_SCHEMA,
      postalCode: z.string().min(1, 'Provide hub postal code'),
      country: z.string(),
      nationalManagerId: z.string(),
      nationalManagerName: z.string(),
      regionalManagerId: z.string(),
      regionalManagerName: z.string(),
      latitude: z.number().min(-90).max(90),
      longitude: z.number().min(-180).max(180),
      isSuperHub: z.boolean(),
    })
    .superRefine(createHubFormValidation(composedSubdivisionsList));

export const useHubFormSchema = () => {
  const { composedSubdivisionsList, isLoading } = useCountriesData();
  const schema = useMemo(() => hubFormSchema(composedSubdivisionsList), [composedSubdivisionsList]);
  return { schema, isLoading };
};
